'use client';

import { Mail, MessageCircle } from 'lucide-react';

import { cn } from '@/lib/utils';

interface NotificationBannerProps {
  variant: 'destructive' | 'info' | 'light';
  text: string;
  dataHook: string;
  ctaLabel?: string;
  onCtaClick?: () => void;
}

export function NotificationBanner({
  variant,
  text,
  dataHook,
  ctaLabel,
  onCtaClick,
}: NotificationBannerProps) {
  if (variant === 'light') {
    return (
      <div
        data-hook={dataHook}
        className="flex items-center gap-3 rounded-lg border border-border px-3 py-2.5 text-sm text-foreground"
      >
        <MessageCircle size={16} className="shrink-0 text-muted-foreground" />
        <span className="flex-1">{text}</span>
        {ctaLabel && onCtaClick ? (
          <button
            type="button"
            data-hook={`${dataHook}-cta`}
            onClick={onCtaClick}
            className="shrink-0 text-primary underline hover:opacity-80"
          >
            {ctaLabel}
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <div
      data-hook={dataHook}
      className={cn(
        'flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm',
        variant === 'destructive'
          ? 'bg-red-50 text-red-700'
          : 'bg-[#000624] text-white',
      )}
    >
      {variant === 'info' ? (
        <Mail size={16} className="shrink-0 opacity-80" />
      ) : null}
      <span>
        {text}
        {ctaLabel && onCtaClick ? (
          <>
            {' '}
            <button
              type="button"
              data-hook={`${dataHook}-cta`}
              onClick={onCtaClick}
              className="underline hover:opacity-80"
            >
              {ctaLabel}
            </button>
          </>
        ) : null}
      </span>
    </div>
  );
}
